// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBContainer, MDBRow } from 'mdbreact';

const SectionContainer = ({ children }) => (
  <div fluid>
    {
      children.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="">
          {child}
        </div>
      ))
    }
  </div>
);

export default SectionContainer;
